'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _multipleSmallNumbers = require('./multiple-small-numbers');
var _multipleSmallNumbers2 = _interopRequireDefault(_multipleSmallNumbers);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
TimeInYearsMonths.defaultProps = {
  name: 'timeYearsMonths',
  label: 'Please enter a value (years/months)'
};
function TimeInYearsMonths(props) {
  return _react2.default.createElement(_multipleSmallNumbers2.default, Object.assign({}, props, {
    inputNames: ['years', 'months']
  }));
}
exports.default = TimeInYearsMonths;